import type { App } from 'vue';
import { createPinia } from 'pinia';
import type { Pinia } from 'pinia';
import piniaPluginPersist from 'pinia-plugin-persist';

// 创建一个共享的 store 实例
let store: Pinia | null = null;

/**
 * 创建并配置 Pinia store 实例
 */
export function createStore(): Pinia {
  if (!store) {
    store = createPinia();
    store.use(piniaPluginPersist);
  }
  return store;
}

/**
 * 设置并安装 store 到 Vue 应用
 */
export function setupStore(app: App<Element>): Pinia {
  const piniaStore = createStore();
  app.use(piniaStore);
  return piniaStore;
}

/**
 * 获取全局 store 实例
 */
export function getStore(): Pinia | null {
  return store;
}
